import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import Tag from '..';

interface Props {
  isPreApproved?: boolean;
  noIcon?: boolean;
}

const ApprovedTag = ({ isPreApproved, noIcon }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Tag icon={noIcon ? undefined : 'check'} color="green">
      {t(isPreApproved ? 'dashboard.card.preApprovedTag' : 'dashboard.card.approvedTag')}
    </Tag>
  );
};

export default ApprovedTag;
